import * as scssStyles from '$CSS/settings.scss';

export const eventStatusIndicatorColors: { [key: string]: { background: string; color: string } } = {};
eventStatusIndicatorColors['New'] = { background: scssStyles.newStatusIndicatorBackground, color: scssStyles.newStatusIndicatorColor };
eventStatusIndicatorColors['Sent_To_Driver'] = {
    background: scssStyles.sentToDriverStatusIndicatorBackground,
    color: scssStyles.sentToDriverStatusIndicatorColor,
};
eventStatusIndicatorColors['Dismissed'] = {
    background: scssStyles.dismissedStatusIndicatorBackground,
    color: scssStyles.dismissedStatusIndicatorColor,
};
eventStatusIndicatorColors['Completed'] = {
    background: scssStyles.completedStatusIndicatorBackground,
    color: scssStyles.completedStatusIndicatorColor,
};
eventStatusIndicatorColors['Driver_Disputed'] = {
    background: scssStyles.driverDisputedStatusIndicatorBackground,
    color: scssStyles.driverDisputedStatusIndicatorColor,
};
eventStatusIndicatorColors['Driver_Accepted'] = {
    background: scssStyles.driverAcceptedStatusIndicatorBackground,
    color: scssStyles.driverAcceptedStatusIndicatorColor,
};
eventStatusIndicatorColors['In_Progress'] = {
    background: scssStyles.inProgressStatusIndicatorBackground,
    color: scssStyles.inProgressStatusIndicatorColor,
};
eventStatusIndicatorColors['No_Response'] = {
    background: scssStyles.noResponseStatusIndicatorBackground,
    color: scssStyles.noResponseStatusIndicatorColor,
};
